
import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import * as yup from 'yup';

import Brand, { selectBrand } from 'store/models/Brand';

import Modal, { ModalHeader, ModalTitle, ModalSubtitle, ModalContent, ModalActions } from 'components/Modal';
import Button, { CopyButton, SaveButton } from 'components/Button';
import { Form,  withForm } from 'components/forms/Form';
import TextInput from 'components/forms/TextInput';


const Inputs = {
  name: {
    validate: yup.string().trim().required(),
  }
}



// ======================
// STORE
// ====================== 
const actions = {
  createBrand: Brand.actions.createBrand,
  updateBrand: Brand.actions.updateBrand,
}

const selectors = (state, props) => {
  return {
    brand: selectBrand(state, props.brandId),
  };
}

const withConnect = connect(selectors, actions);

// ======================
// COMPONENT
// ====================== 
class BrandEditModal extends React.Component {


  componentDidMount = async () => {
    await this.props.setSchema(Inputs);
    if(this.props.brand)
      this.props.setDefaults({ name: this.props.brand.name })
  }

  onSave = async () => {
    let { brandId } = this.props;
    let values = await this.props.validateForm();
    if(!values)
      return;

    try {
      this.setState({ saving: true });
      if(brandId) {
        await this.props.updateBrand(brandId, values);
      } else {
        await this.props.createBrand(values);
      }
      this.props.closeModal();
      this.props.onSuccess?.();
    } catch(err) {

    }
  }

  render() {
    let { values, errors, brandId, onInputChange } = this.props;
    let isCreate = _.isEmpty(brandId);
    return (
      <Modal id="brand-edit" className="s">
        <ModalHeader>
          <ModalTitle>{isCreate ? "Create New Brand" : "Edit Brand Name"}</ModalTitle>
        </ModalHeader>
        <ModalContent>
          <Form onSubmit={this.onSave}>
            <TextInput 
              label="Brand Name"
              name="name"
              value={values.name}
              align="center"
              size="l"
              focused={true}
              helper="This name is what you'll see in all your reports"
              onChange={onInputChange}/>
          </Form>
        </ModalContent>
        <ModalActions>
          <SaveButton onClick={this.onSave} />
        </ModalActions>
      </Modal>);
  }
};
export default BrandEditModal
  |> withConnect
  |> withForm;
